import React from 'react';
import { Avatar, Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { brandTokens } from '../single-page/theme';

const Root = styled('section')(({ theme }) => ({
  backgroundColor: brandTokens.navy,
  color: '#ffffff',
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(6),
  [theme.breakpoints.down('sm')]: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(5),
  },
}));

const Content = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(2),
    textAlign: 'center',
  },
}));

const AvatarGroup = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

const OverlapAvatar = styled(Avatar)(({ bgcolor }) => ({
  width: 52,
  height: 52,
  fontFamily: 'GT Haptik, Roboto, sans-serif',
  fontWeight: 700,
  fontSize: '1rem',
  color: brandTokens.navy,
  backgroundColor: bgcolor,
  border: `2px solid ${brandTokens.navy}`,
  marginLeft: -14,
  '&:first-of-type': {
    marginLeft: 0,
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  fontFamily: 'GT Haptik, Raleway, sans-serif',
  fontWeight: 700,
  fontSize: 'clamp(1.5rem, 3vw, 2.25rem)',
  lineHeight: 1.2,
  letterSpacing: '-0.01em',
  color: '#ffffff',
  maxWidth: 420,
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
  },
}));

const avatars = [
  { id: 'ms', initials: 'MS', color: brandTokens.cyan },
  { id: 'jp', initials: 'JP', color: brandTokens.green },
  { id: 'ac', initials: 'AC', color: brandTokens.cyanMuted },
  { id: 'rb', initials: 'RB', color: brandTokens.blueAccent },
];

const ConsultationsProof = () => {
  return (
    <Root>
      <Container maxWidth="lg">
        <Content>
          <AvatarGroup aria-hidden="true">
            {avatars.map((a) => (
              <OverlapAvatar key={a.id} bgcolor={a.color}>
                {a.initials}
              </OverlapAvatar>
            ))}
          </AvatarGroup>
          <Title variant="h2">Mais de 50.000 consultas realizadas.</Title>
        </Content>
      </Container>
    </Root>
  );
};

export default ConsultationsProof;
